
import { css } from 'lit';
export default css`
:host{
  display:block;
  --wysiwyg-font-color:var(--neutral-medium-gray);
}

.story-card{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-2);
  padding:var(--spacing-6) 0;
  border-bottom:2px solid var(--purple-medium-neutral);
}

@media (min-width: 992px){

.story-card{
    padding:var(--spacing-8) 0
}
  }

.cta-wrapper{
  display:flex;
  flex-direction:column;
  gap:1rem;
  margin-top:1rem;
}
`;